import * as nacl from "tweetnacl";
import * as naclUtils from "tweetnacl-util";

export function encrypt(recipientPublicKey: string, message: string): string {
    try {
        // Decode the recipient's public key from base64
        const recipientPublicKeyUint8Array = naclUtils.decodeBase64(recipientPublicKey);
        
        // Generate an ephemeral key pair for this encryption
        const ephemeralKeyPair = nacl.box.keyPair();
        
        // Create a random nonce
        const nonce = nacl.randomBytes(nacl.box.nonceLength);
        
        // Convert the message to Uint8Array
        const messageUint8Array = naclUtils.decodeUTF8(message);
        
        // Encrypt the message
        const ciphertext = nacl.box(
            messageUint8Array,
            nonce,
            recipientPublicKeyUint8Array,
            ephemeralKeyPair.secretKey
        );
        
        // Combine nonce, ephemeral public key, and ciphertext
        const encryptedMessage = new Uint8Array(
            nonce.length + ephemeralKeyPair.publicKey.length + ciphertext.length
        );
        
        encryptedMessage.set(nonce, 0);
        encryptedMessage.set(ephemeralKeyPair.publicKey, nonce.length);
        encryptedMessage.set(ciphertext, nonce.length + ephemeralKeyPair.publicKey.length);
        
        // Return as base64 encoded string
        return naclUtils.encodeBase64(encryptedMessage);
    } catch (error) {
        throw error;
    }
}